module.exports = __webpack_public_path__ + "static/media/logoPlaceholder.b5627164.png";